import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=4128c373&scoped=true"
import script from "./NewsCenter.vue?vue&type=script&lang=js"
export * from "./NewsCenter.vue?vue&type=script&lang=js"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=4128c373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128c373",
  null
  
)

export default component.exports